var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.3,
    height: 45.186,
    viewBox: "0 0 127.3 45.186",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-1719.179 -681.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1719.179 681.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1736,539.382a11.635,11.635,0,0,0-7.242,2.606v-15.44a14.908,14.908,0,0,0-3.995-.878c-2.339-.075-4.147.5-4.906,1.608a4.176,4.176,0,0,0-.666,2.53v40.2h9.626V554.6c0-5.092,2.782-6.482,5.654-6.482,2.632,0,5.4.823,5.4,5.66V570.01h9.627V551.851C1749.5,542.253,1742.89,539.124,1736,539.382Z",
    transform: "translate(-1719.179 -525.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2135.036,690.526a6.28,6.28,0,0,0-3.648.956,3.727,3.727,0,0,0-1.375,3.292v26.238h9.623V691.42c-.235-.075-.8-.248-1.67-.514A10.46,10.46,0,0,0,2135.036,690.526Z",
    transform: "translate(-2093.744 -676.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M2327.855,571.151a13.293,13.293,0,0,0-8.766,3.207v-13c-.239-.074-.79-.243-1.656-.493a10.317,10.317,0,0,0-2.913-.376,6.465,6.465,0,0,0-3.669.927,3.585,3.585,0,0,0-1.385,3.211v20.861c0,13.136,8.3,17.028,16.62,17.028,6.912,0,16.5-4.345,16.5-15.686C2342.584,579.778,2338.075,571.513,2327.855,571.151Zm-1.98,22.742c-5,0-6.846-3.8-6.846-7.087,0-2.572,1.7-7.081,6.846-7.081,5.071,0,6.846,4.221,6.846,7.081C2332.721,590.457,2330.438,593.893,2325.875,593.893Z",
    transform: "translate(-2257.684 -557.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M2758.78,690.847a10.416,10.416,0,0,0-2.927-.385,6.253,6.253,0,0,0-3.644.956,3.712,3.712,0,0,0-1.374,3.292v12.012q0,6.221-5.618,6.219t-5.622-6.219V691.354c-.243-.075-.8-.248-1.678-.514a10.416,10.416,0,0,0-2.925-.385,6.285,6.285,0,0,0-3.651.956,3.727,3.727,0,0,0-1.375,3.292v13.811c0,3.5,1.313,13.273,15.25,13.273,13.673,0,15.243-9.776,15.243-13.273v-17.16C2760.218,691.28,2759.661,691.106,2758.78,690.847Z",
    transform: "translate(-2641.485 -676.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M2129.206,536.577a4.9,4.9,0,1,1,4.9,4.9,4.9,4.9,0,0,1-4.9-4.9Z",
    transform: "translate(-2093.028 -531.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M2730.168,536.577a4.9,4.9,0,1,1,4.9,4.9A4.9,4.9,0,0,1,2730.168,536.577Z",
    transform: "translate(-2640.965 -531.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M2960.685,536.577a4.9,4.9,0,1,1,4.9,4.9A4.9,4.9,0,0,1,2960.685,536.577Z",
    transform: "translate(-2851.345 -531.129)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(122.047 15.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3102.033,704.868h-.91v-.321h2.205v.321h-.91v2.691h-.385Z",
    transform: "translate(-3101.123 -704.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3131.415,704.547h.45l.583,1.617.22.616h.019l.211-.616.58-1.617h.45v3.012h-.364V705.9c0-.266.028-.625.051-.891h-.015l-.244.67-.578,1.575h-.216l-.583-1.575-.239-.67h-.018c.018.266.05.625.05.891v1.658h-.356Z",
    transform: "translate(-3128.674 -704.547)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyHeaderLogo);
export default __webpack_public_path__ + "static/media/company-header-logo.295980a478e855457b1e47eb7149b1ac.svg";
export { ForwardRef as ReactComponent };